import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesComponent } from './sales/sales.component';
import { RouterModule } from '@angular/router';
import { SalesRoutingModule } from './sales-routing.module';
import { OrderRoutingModule } from '../order/order-routing.module';
import { PageHeaderComponent } from 'src/app/components/page-header/page-header.component';
import { SimpleTableComponent } from 'src/app/components/simple-table/simple-table.component';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { FieldWithLabelComponent } from 'src/app/components/field-with-label/field-with-label.component';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';

@NgModule({
	declarations: [SalesComponent],
	imports: [
		CommonModule,
		RouterModule.forChild(SalesRoutingModule),
		CommonModule,
		RouterModule.forChild(OrderRoutingModule),
		PageHeaderComponent,
		SimpleTableComponent,
		FormsModule,
		CalendarModule,
		FieldWithLabelComponent,
		DropdownModule,
		ButtonModule,
	],
})
export class SalesModule {}
